import { Form, Field } from 'react-final-form';
import ReactGA from 'react-ga';
import { useContext } from 'react';

import * as Styled from './free-consultation.styles';
import { composeValidators, fieldRequired, maxLength, ToastContext, validateEmail } from '../../helpers';
import { FieldError } from '../../components';
import { BookCallService } from '../../services';
import { useNavigate } from 'react-router-dom';

const FormValuesFields = {
    name: 'name',
    email: 'email',
    message: 'message',
};

const fields = [
    {
        name: FormValuesFields.name,
        placeholder: 'Name',
        type: 'text',
        validate: fieldRequired,
    },
    {
        name: FormValuesFields.email,
        placeholder: 'Email',
        type: 'email',
        validate: composeValidators(fieldRequired, validateEmail),
    },
    {
        name: FormValuesFields.message,
        placeholder: 'Briefly describe your question',
        type: 'text',
        validate: maxLength(500),
    },
];

const FreeConsultation = () => {
    const navigate = useNavigate();

    const onSubmit = (values) => {
        return BookCallService.bookCall(values);
    };

    const { open } = useContext(ToastContext);

    const errorNotification = () => {
        open({ type: 'Error', content: 'Something went wrong. Please try again!' });
    };

    return (
        <Styled.Container>
            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit, submitting, form }) => (
                    <Styled.Form
                        onSubmit={(event) => {
                            const promise = handleSubmit(event);
                            if (promise) {
                                promise
                                    .then(() => {
                                        ReactGA.event({
                                            category: 'User',
                                            action: "User filled a 'Free Consultation' and sent a request",
                                        });
                                        Object.keys(FormValuesFields).forEach((key) => {
                                            form.change(key, undefined);
                                            form.resetFieldState(key);
                                        });
                                        navigate('/thank-you', { state: { isFromApp: true } });
                                    })
                                    .catch(() => {
                                        errorNotification();
                                    });
                                return promise;
                            }
                        }}>
                        <Styled.MainTitle>Free Consultation</Styled.MainTitle>
                        <Styled.SubTitle>Request a 15-min call with an expert</Styled.SubTitle>
                        {fields.map(({ name, validate, type, placeholder }) => (
                            <Field name={name} validate={validate} key={name}>
                                {({ input, meta }) => (
                                    <Styled.FieldBlock>
                                        <Styled.FieldInput
                                            isError={meta.touched && meta.error}
                                            type={type}
                                            {...input}
                                            placeholder={placeholder}
                                        />
                                        <FieldError meta={meta} />
                                    </Styled.FieldBlock>
                                )}
                            </Field>
                        ))}

                        <Styled.SubmitButton type='submit' disabled={submitting}>
                            <Styled.SubmitButtonText>Submit</Styled.SubmitButtonText>
                        </Styled.SubmitButton>
                    </Styled.Form>
                )}
            />
        </Styled.Container>
    );
};

export default FreeConsultation;
